import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import type {PayloadAction} from '@reduxjs/toolkit'
import financeService from './financeService'

// Get Organization
export const ListOrganization = createAsyncThunk(
  'organization-list',
  async (params: {}, thunkAPI) => {
    try {
      return await financeService.organizationList({params})
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Create Organization
export const createOrganization = createAsyncThunk(
  'organization-create',
  async (data: {}, thunkAPI) => {
    try {
      return await financeService.organizationCreate({data})
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Get Organization id
export const editOrganization = createAsyncThunk(
  'organization-edit',
  async (id: string, thunkAPI) => {
    try {
      return await financeService.organizationEdit(id)
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Delete Organization
export const deleteOrganization = createAsyncThunk(
  'organization-delete',
  async (id: string, thunkAPI) => {
    try {
      return await financeService.organizationDelete(id)
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// view Organization
export const viewOrganization = createAsyncThunk(
  'organization-view',
  async (id: string, thunkAPI) => {
    try {
      return await financeService.organizationView(id)
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Get Currency
export const ListCurrency = createAsyncThunk('currency-list', async (params: {}, thunkAPI) => {
  try {
    return await financeService.currencyList({params})
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// Create Currency
export const createCurrency = createAsyncThunk('currency-create', async (data: {}, thunkAPI) => {
  try {
    return await financeService.currencyCreate({data})
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// Get Currency id
export const editCurrency = createAsyncThunk('currency-edit', async (id: string, thunkAPI) => {
  try {
    return await financeService.currencyEdit(id)
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// Delete Currency
export const deleteCurrency = createAsyncThunk('currency-delete', async (id: string, thunkAPI) => {
  try {
    return await financeService.currencyDelete(id)
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// Get StudentList
export const ListStudent = createAsyncThunk('student-list', async (_, thunkAPI) => {
  try {
    return await financeService.studentList()
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// Get StudentList
export const GetStudentDetails = createAsyncThunk(
  'student-details',
  async ({id, type}: {id: string; type: string}, thunkAPI) => {
    try {
      return await financeService.studentDetails(id, type)
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const GetStdProgram = createAsyncThunk('student-program', async (id: string, thunkAPI) => {
  try {
    return await financeService.getStdProgram(id)
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// Create createStudentInvoice
export const createStudentInvoice = createAsyncThunk(
  'student-invoice-create',
  async (data: {}, thunkAPI) => {
    try {
      return await financeService.studentInvoiceCreate({data})
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Get ListStudentInvoice
export const ListStudentInvoice = createAsyncThunk(
  'student-invoice-list',
  async (params: {}, thunkAPI) => {
    try {
      return await financeService.studentInvoiceList({params})
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Delete deleteStudentInvoice
export const deleteStudentInvoice = createAsyncThunk(
  'student-invoice-delete',
  async (id: string, thunkAPI) => {
    try {
      return await financeService.studentInvoiceDelete(id)
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Get StudentInvoiceDetails
export const studentInvoiceDetails = createAsyncThunk(
  'student-invoice-details',
  async (id: string, thunkAPI) => {
    try {
      return await financeService.studentInvoiceDetails(id)
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const editStudentInvoiceInvoice = createAsyncThunk(
  'recurring-frequency-edit',
  async (id: string, thunkAPI) => {
    try {
      return await financeService.studentInvoiceInvoiceEdit(id)
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

//  getPayments
export const GetPayments = createAsyncThunk('get-payments', async (id: string, thunkAPI) => {
  try {
    return await financeService.getPayments(id)
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// Create CreateStudentInvoicePayment
export const CreateStudentInvoicePayment = createAsyncThunk(
  'student-invoice-payment-create',
  async (data: {}, thunkAPI) => {
    try {
      return await financeService.studentInvoicePaymentCreate({data})
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// PrintApplicationLetter
export const PrintStudentInvoice = createAsyncThunk(
  'print-student-invoice',
  async (id: string, thunkAPI) => {
    try {
      return await financeService.invoicePrint(id)
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// email StudentInvoice
export const emailStudentInvoice = createAsyncThunk(
  'student-invoice-email',
  async (id: string, thunkAPI) => {
    try {
      return await financeService.studentInvoiceEmail(id)
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const InvoiceSummary = createAsyncThunk('invoice-summary', async (_, thunkAPI) => {
  try {
    return await financeService.invoiceSummary()
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const changeInstallmentDate = createAsyncThunk(
  'change-installment-date',
  async (data: {}, thunkAPI) => {
    try {
      return await financeService.changeInstallmentDate({data})
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const PaymentDelete = createAsyncThunk('payment-delete', async (id: string, thunkAPI) => {
  try {
    return await financeService.paymentDelete(id)
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const StdInvoices = createAsyncThunk('std-invoice', async (id: string, thunkAPI) => {
  try {
    return await financeService.stdInvoices(id)
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const OrgInvoiceCreate = createAsyncThunk(
  'org-invoice-create',
  async (data: {}, thunkAPI) => {
    try {
      return await financeService.orgInvoiceCreate({data})
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const OrgInvoiceList = createAsyncThunk('org-invoice-list', async (params: {}, thunkAPI) => {
  try {
    return await financeService.orgInvoiceList({params})
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const OrgInvoices = createAsyncThunk('org-invoices', async (id: string, thunkAPI) => {
  try {
    return await financeService.orgInvoices(id)
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const OrgInvoiceInvoiceEdit = createAsyncThunk(
  'org-invoice-edit',
  async (id: string, thunkAPI) => {
    try {
      return await financeService.orgInvoiceInvoiceEdit(id)
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const OrgInvoiceDelete = createAsyncThunk(
  'org-invoice-delete',
  async (id: string, thunkAPI) => {
    try {
      return await financeService.orgInvoiceDelete(id)
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const OrgInvoiceDetails = createAsyncThunk(
  'org-invoice-details',
  async (id: string, thunkAPI) => {
    try {
      return await financeService.orgInvoiceDetails(id)
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const OrgChangeInstallmentDate = createAsyncThunk(
  'org-change-installment-date',
  async (data: {}, thunkAPI) => {
    try {
      return await financeService.orgChangeInstallmentDate({data})
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const GetOrgPayments = createAsyncThunk('get-org-payments', async (id: string, thunkAPI) => {
  try {
    return await financeService.getOrgPayments(id)
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const OrgInvoicePaymentCreate = createAsyncThunk(
  'org-invoice-payment-create',
  async (data: {}, thunkAPI) => {
    try {
      return await financeService.orgInvoicePaymentCreate({data})
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const OrgInvoicePrint = createAsyncThunk(
  'print-org-invoice',
  async (id: string, thunkAPI) => {
    try {
      return await financeService.orgInvoicePrint(id)
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const OrgPaymentDelete = createAsyncThunk(
  'org-payment-delete',
  async (id: string, thunkAPI) => {
    try {
      return await financeService.orgPaymentDelete(id)
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const EmailOrgInvoice = createAsyncThunk(
  'org-invoice-email',
  async (id: string, thunkAPI) => {
    try {
      return await financeService.orgInvoiceEmail(id)
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const OrgInvoiceSummary = createAsyncThunk('org-invoice-summary', async (_, thunkAPI) => {
  try {
    return await financeService.orgInvoiceSummary()
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const GetInvDetails = createAsyncThunk('get-inv-details', async (id: string, thunkAPI) => {
  try {
    return await financeService.getInvDetails(id)
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const InvoiceUpdate = createAsyncThunk('invoice-update', async (data: {}, thunkAPI) => {
  try {
    return await financeService.invoiceUpdate({data})
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const GetInvOrgDetails = createAsyncThunk(
  'get-org-inv-details',
  async (id: string, thunkAPI) => {
    try {
      return await financeService.getInvOrgDetails(id)
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const InvoiceOrgUpdate = createAsyncThunk(
  'invoice-org-update',
  async (data: {}, thunkAPI) => {
    try {
      return await financeService.invoiceOrgUpdate({data})
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

type FinanceState = {
  record: any
  records: any
  errors: any
}

const initialState: FinanceState = {
  records: {
    data: [],
  },
  record: {},
  errors: '',
}

export const financeSlice = createSlice({
  name: 'finance',
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(ListOrganization.fulfilled, (state, action: PayloadAction<any>) => {
        state.records = action.payload
      })
      .addCase(ListCurrency.fulfilled, (state, action: PayloadAction<any>) => {
        state.records = action.payload
      })
      .addCase(createCurrency.rejected, (state, action: PayloadAction<any>) => {
        state.errors = action.payload
      })
      .addCase(createStudentInvoice.rejected, (state, action: PayloadAction<any>) => {
        state.errors = action.payload
      })
      .addCase(ListStudentInvoice.fulfilled, (state, action: PayloadAction<any>) => {
        state.records = action.payload
      })
  },
})

export const {reset} = financeSlice.actions
export default financeSlice.reducer
